import React from "react"
import Hero from "./components/Hero"
import Statistics from "./components/Statistics"
import BrandDescription from "./components/BrandDescription"
import CoffeeSection from "./components/CoffeeSection"
import TeaSection from "./components/TeaSection"
import FinalMessage from "./components/FinalMessage"

const AboutPage: React.FC = (): JSX.Element => {
  return (
    <div className="bg-white">
      <Hero />
      <Statistics />
      <BrandDescription />
      <CoffeeSection />
      <TeaSection />
      <FinalMessage />
    </div>
  )
}

export default AboutPage
